import { useState } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  MaskedInput,
  TextField,
} from "../../../../../components";
import { nfSaidaIntermediadorValidator } from "../../middlewares";
import { InputErros, ValidarCpfCnpjHelper } from "../../../../../helpers";
import { notification } from "../../../../../services";

const validarCpfCnpjHelper = new ValidarCpfCnpjHelper();

const IntermediadorDialog = ({
  open,
  setOpen,
  infoDialog,
  setInfoDialog,
  setIntermediadorSelecionado,
  nfSaidaEntity,
  setNfSaida,
  setEditarIntermediador,
}) => {

  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);

  async function verificarDocumento(cnpj) {
    if (cnpj.length != 14) {
      inputErros.gerar("cnpj");
      throw new Error(`Documento inválido`);
    }
    const documentoValido = validarCpfCnpjHelper.cnpj(cnpj, true);
    if (!documentoValido) {
      inputErros.gerar("cnpj");
      throw new Error(`CNPJ inválido`);
    }
  }

  const adicionarIntermediador = () => {
    nfSaidaIntermediadorValidator
      .validate(infoDialog, { abortEarly: false })
      .then(async () => {
        try {
          await verificarDocumento(infoDialog.cnpjCpf);
        } catch (error) {
          return notification.alertaGenericos(error.message);
        }

        nfSaidaEntity.setIdentificarIntermediador(infoDialog);
        setIntermediadorSelecionado(infoDialog);
        setNfSaida((prevState) => ({ ...prevState, nfSaidaEntity }));
        setEditarIntermediador(true);
        inputErros.set(null);
        setOpen(false);
      })
      .catch((err) => {
        inputErros.set(err);
      });
  };

  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth
      maxWidth="md"
      PaperComponent="div"
      open={open}
      aria-labelledby="form-dialog-title"
    >
      <DialogContent>
        <Card className="p-3">
          <CardHeader title={"Adicionar Intermediador"} />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <TextField
                  id="addIntermediadorRazaoSocial"
                  name="addIntermediadorRazaoSocial"
                  label="Razão Social"
                  variant="outlined"
                  value={infoDialog?.nomeRazaoSocial}
                  onChange={(e) =>
                    setInfoDialog((prevState) => ({
                      ...prevState,
                      nomeRazaoSocial: e.target.value
                    }))
                  }
                  error={inputErros.get("razaoSocial")}
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={4}>
                <MaskedInput
                  id="addIntermediadorCnpj"
                  label={"CNPJ"}
                  name="addIntermediadorCnpj"
                  variant="outlined"
                  margin="none"
                  required
                  mask={"**.***.***/****-99"}
                  onChange={(e) => setInfoDialog((prevState) => ({
                    ...prevState,
                    cnpjCpf: e.target.value
                  }))}
                  error={inputErros.get("cnpj")}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Button
              id="botaoSalvar"
              color="primary"
              variant="contained"
              onClick={adicionarIntermediador}
            >
              <i
                className="ph-fill ph-check-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              ></i>
              Adicionar
            </Button>
            <Button
              color="inherit"
              variant="contained"
              onClick={() => setOpen(false)}
            >
              <i
                className="ph-fill ph-x-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              ></i>
              Fechar
            </Button>
          </CardActions>
        </Card>
      </DialogContent>
    </Dialog>
  );
};

export default IntermediadorDialog;
